export { SpecsIcon } from "./specs";
